import { MMKV } from 'react-native-mmkv'

import { captureException } from '@/src/config/sentry'

export enum STORAGE_KEYS {
  LANG = 'lang',
  TOKEN = 'token',
  ASK_BECOME_WATCHMAN_PERIOD = 'askBecomeWatchmanPeriod',
  ME = 'me',
  ALERTS_CONSULTED = 'alerts-consulted',
  PRAYED_INTENTIONS = 'prayed_intentions',
  COMMUNITY_VIEWS = 'community_views',
  /** Record if the donation banner should be shown - should be set to true until the user has dismissed it or donated */
  XMRPM_CTA = 'xmrpm_cta',
  DONATION_BANNER_NOT_BEEN_DISMISSED = 'donation_banner_not_been_dismissed',
  WATCHMAN_INITIAL_INTENTION = 'watchman_initial_intention',
  WATCHMAN_PUSH_CTA = 'watchman_push_cta',
  WATCHMAN_STREAK_ANIMATED_TODAY = 'watchman_streak_animated_today',
  NEW_PRAYER_SPACE_MODAL_SHOWN = 'new_prayer_space_modal_shown',
  PAPA_QUIZ_BANNER_DISMISSED = 'papa_quiz_banner_dismissed',
}

// Storage interface is a native interface from the DOM API, our utils such as Zustand are built on top of it
class MMKVStorage implements Storage {
  private storage = new MMKV({ id: 'hozana' })

  clear(): void {
    return this.storage.clearAll()
  }

  getItem(key: string): string | null {
    const val = this.storage.getString(key)
    return val || null
  }

  key(index: number): string | null {
    return this.storage.getAllKeys()[index] || null
  }

  removeItem(key: string): void {
    return this.storage.delete(key)
  }

  setItem(key: string, value: string): void {
    try {
      this.storage.set(key, value)
    } catch (err) {
      if (err instanceof Error && err.message) {
        captureException.then((f) => f(err))
      }
    }
  }

  get length(): number {
    return this.storage.getAllKeys().length
  }
}

export const storage = new MMKVStorage()
